//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import SmallLoadingWrapper from '../../../Loading/SmallLoadingWrapper';
import { TrekOverviewIcon as Icons } from '../../../../constants/icons';

import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../../../redux/actions/overviewEditorActions';

import {
  closeOverviewModal,
  closeEditor,
} from '../../../../redux/actions/trekOverviewActions';

import { getToastMsg } from '../../../ErrorMessage';

import { Formik, Field } from 'formik';
import { BasicInfoEditorSchema } from '../../constants';

type Props = {
  minSize: number,
  maxSize: number,
  followers: Array<string>,
  renderedAsModal: boolean,
  trekId: string,
  closeOverviewModal: () => void,
  closeEditorl: () => void,
  patchOverviewEditsl: () => void,
  updateOverviewEditsl: () => void,
};

type IconCompProps = {
  type: string,
};

type State = {
  loading: boolean,
};
const IconComp = ({ type }: IconCompProps) => <i className={Icons[type]} />;

class BasicInfoEditor extends Component<Props, State> {
  state = { loading: false };

  render() {
    const { renderedAsModal, closeOverviewModal, minSize, maxSize } = this.props;
    const { loading } = this.state;

    const basicInfoComp = [
      { icon: 'sun', label: 'Minimum Size', value: minSize, key: 'min', placeholder: '1' },
      { icon: 'sun', label: 'Maximum Size', value: maxSize, key: 'max', placeholder: '11' },
    ];

    return (
      <div id="basic-info-editor" className="white-panel">
        <SmallLoadingWrapper showLoading={loading}>
          <Formik
            initialValues={{
              min: minSize,
              max: maxSize,
            }}
            validationSchema={BasicInfoEditorSchema}
            onSubmit={values => {
              this.handleSave(values);
            }}
            render={({ handleSubmit, errors }) => (
              <form onSubmit={handleSubmit}>
                <div className="d-mobile">
                  <div className="d-flex justify-content-between">
                    {renderedAsModal && (
                      <a onClick={closeOverviewModal}>
                        <i className="icon icon-hg-chev-left" aria-hidden="true" />
                      </a>
                    )}
                    <h2>
                      BASIC INFORMATION
                      <button type="submit" className="save-btn" style={{ float: 'right' }}>
                        <i className="icon icon-hg-save" aria-hidden="true" /> Save
                      </button>
                    </h2>
                  </div>
                </div>
                <ul className="imp-info-edit clearfix">
                  {basicInfoComp.map(v => (
                    <li key={v.key}>
                      <div className="count-holder">
                        <div className="count-wrap">
                          <h4>
                            <Field
                              name={v.key}
                              type="number"
                              component="input"
                              placeholder={v.placeholder}
                            />
                            {errors[v.key] && (
                              <p className="error">{this.reformatError(errors[v.key])}</p>
                            )}
                          </h4>
                          <div className="icon-holder">
                            <IconComp type={v.icon} />
                            {v.label}
                            {v.extraComp}
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </form>
            )}
          />
        </SmallLoadingWrapper>
      </div>
    );
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      window.addEventListener('click', this.handleOutsideClick);
    }, 10);
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
    window.removeEventListener('click', this.handleOutsideClick);
  }

  setLoadingState = status => this.setState(() => ({ loading: status }));

  reformatError = error =>
    error.includes('must be a `number` type') ? 'Should be a number' : error;

  handleSave = values => {
    const {
      patchOverviewEdits,
      updateOverviewEdits,
      closeOverviewModal,
      renderedAsModal,
      closeEditor,
      trekId,
    } = this.props;

    const { min, max } = values;

    this.setLoadingState(true);

    const patchObj = { group_size: { minimum: +min, maximum: +max } };
    patchOverviewEdits(trekId, patchObj)
      .then(() => {
        updateOverviewEdits(patchObj);
        if (renderedAsModal) {
          closeOverviewModal();
        } else {
          closeEditor();
        }
        getToastMsg({ status: 'success', type: 'changeTrekBasicInfo' });
        this.setLoadingState(false);
      })
      .catch(() => {
        getToastMsg({ status: 'error', type: 'changeTrekBasicInfo' });
        this.setLoadingState(false);
      });
  };

  handleOutsideClick = e => {
    const { loading } = this.state;
    if (!document.getElementById('basic-info-editor').contains(e.target)) {
      if (!loading) {
        this.props.closeEditor();
      }
    }
  };
}

const mapStateToProps = ({ selectedTrek, trekOverview }) => ({
  trekId: selectedTrek.trek.id,
  renderedAsModal: trekOverview.isModalOpen,
});

export default connect(
  mapStateToProps,
  {
    closeEditor,
    patchOverviewEdits,
    updateOverviewEdits,
    closeOverviewModal,
  }
)(BasicInfoEditor);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/BasicInfo/BasicInfoEditor.jsx